module.exports = __webpack_public_path__ + "static/media/close-mini__icon.c8a63cd4.svg";